export default __webpack_public_path__ + "static/media/delivery.9d9a01a8.png";